import React from 'react';
import { motion } from 'framer-motion';
import { Clock, TrendingDown, Building2 } from 'lucide-react';
export function HookSection() {
  return <section className="py-20 px-4 bg-navy-800 relative" data-id="element-152">
      <div className="max-w-4xl mx-auto" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="space-y-8 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-154">
          <div className="flex items-start gap-4" data-id="element-155">
            <Clock className="text-gold-500 flex-shrink-0 mt-1" size={32} data-id="element-156" />
            <p data-id="element-157">
              <strong className="text-white font-semibold" data-id="element-158">
                ¿Te ha pasado que te despiertas a las 3 AM
              </strong>{' '}
              pensando en cómo vas a pagar la cuota de la CMR o de la Ripley el
              próximo mes?
            </p>
          </div>

          <div className="flex items-start gap-4" data-id="element-159">
            <TrendingDown className="text-gold-500 flex-shrink-0 mt-1" size={32} data-id="element-160" />
            <p data-id="element-161">
              Miras tu cuenta de banco y el sueldo ya se esfumó en puros
              intereses mínimos que no bajan la deuda real. Sientes que trabajas
              solo para que los dueños del retail se hagan más ricos mientras tú
              apenas llegas al día 20.
            </p>
          </div>

          <div className="bg-navy-900/50 p-8 rounded-2xl border border-navy-700 mt-12" data-id="element-162">
            <p className="text-center text-xl md:text-2xl" data-id="element-163">
              Si estás cansado de ver números desconocidos en tu celular y de
              sentir ese vacío en el estómago cada vez que pasas por fuera de
              una sucursal, quiero que sepas algo:
            </p>
            <h2 className="text-2xl md:text-3xl font-bold text-gold-500 text-center mt-6 mb-4" data-id="element-164">
              No es tu culpa. El sistema en Chile está diseñado para que nunca
              termines de pagar.
            </h2>
            <p className="text-center text-white font-medium text-xl" data-id="element-165">
              Pero hoy, ese juego se acaba para ti.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}